
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
// import { Field } from '@core/objects/form';

import { SettingsMultipleChoiceV1Field } from "@core/custom-forms/components/fields/multiple-choice-v1/settings-multiple-choice-v1.class";

import { FormGroup } from '@angular/forms';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown, FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';
import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';

@Component({
    selector: 'form-field-settings-multiple-choice-v1',
    templateUrl: './settings-multiple-choice-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsMultipleChoiceV1FieldComponent implements OnInit, OnChanges {
    @Input() field: SettingsMultipleChoiceV1Field;
    @Output() fieldChange = new EventEmitter<SettingsMultipleChoiceV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the Multiple Choice field";
    public optionsplaceholder: string = "Write the name of the option";
    public form: FormGroup = new FormGroup({});
    public removing: number = -1;
    public menuAddOption: ThreeDotsMenuItem =  {
        title: "Add a new option",
        key: "add-option",
        icon: "add",
        order: 1
    };

    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp, this.menuAddOption];

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        // this.updateMenuItems();
    }
    

    // maybe not needed
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.field){
            // this.updateMenuItems();
            this.cdr.markForCheck();
        }
    }

    // Update creating new objects to ensure change detection    
    onMandatoryChange(mandatory: boolean) {

        this.field = this.field.update({ mandatory: mandatory});
        this.emit(this.field);
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText}))
    }

    onOptionChange(text: string, index: number) {
        if(!this.field.values || !Array.isArray(this.field.values))
            return;
        const newValues = [...this.field.values];
        // Update only the specific index
        newValues[index] = text; 
        this.emit( this.field.update({ values: newValues}) );

    }

    addOption() {
        if(!this.field.values || !Array.isArray(this.field.values))
            return;
        // add an empty string by now as value.
        const newValues = [...this.field.values, ''];
        this.emit( this.field.update({ values: newValues}) );
    }

    // attempt with confirmation
    removeOption(value: string, index: number) {
        this.removing = index;
    }

    // the real action  to remove option from the list
    reallyRemoveOption(value: string, index: number) {
        if(!this.field.values || !Array.isArray(this.field.values))
            return;
        const fieldValues = [...this.field.values];
        const newValues = fieldValues.filter((lo: string, idx: number) => index != idx);
        this.emit( this.field.update({ values: newValues}) );
        this.removing = -1;
    }

    optIsReally(value: string, index: number) : boolean {
        return  index === this.removing;
    }

    onMenuClick(key: string) {
        switch(key) {
            case "add-option":
                this.addOption();
                break;
            case "confirmation-remove":
                this.fieldMenu = [this.menuAddOption, FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case "dismiss-really-remove": // pseudo key to return to basic menu
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, this.menuAddOption, FieldsMenuMoveDown,  FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = {key: key, field: this.field}
                this.menuClick.emit(itemClicked);
        }
    }

    private emit(updatedField:SettingsMultipleChoiceV1Field): void {
        this.fieldChange.emit(updatedField);
    }

    // this track function should prevent loops on options when display the content.
    protected trackByFn(index: number, option: string): any {
        return index; // some unique identifier
    }

    // private updateMenuItems(){
    //     this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp ];
    //     // if(this.field.position == 1 ){
    //     //     this.fieldMenu = (this.total == 1) ? [...FieldsStandardRemoveMenuItem] : [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown]
    //     // } else {
    //     //     this.fieldMenu =  (this.field.position == this.total
    //     //         ? [...FieldsStandardRemoveMenuItem, FieldsMenuMoveUp]
    //     //         : [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp ]);
    //     // }
    // }

}
